import React, { Component } from 'react';

class IconClose extends Component {
  render() {
    return (
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M21.9996 20.5858L15.6356 14.2218L14.2214 15.636L20.5853 22L14.2214 28.364L15.6356 29.7782L21.9996 23.4142L28.3635 29.7782L29.7777 28.364L23.4138 22L29.7777 15.636L28.3635 14.2218L21.9996 20.5858Z" fill="#000000"/>
			</svg>
    )
  }
}

export default IconClose;